export type Range = {
  start: number;
  end: number;
};

export function resolveOverlappingRanges<T extends Range>(
  ranges: T[],
  canMerge: (left: T, right: T) => boolean = () => true,
): T[] {
  const breakpoints = new Set<number>();

  for (const { start, end } of ranges) {
    breakpoints.add(start);
    breakpoints.add(end);
  }

  const sortedBreakpoints = Array.from(breakpoints).sort((a, b) => a - b);
  const resolved: T[] = [];

  for (let index = 0; index < sortedBreakpoints.length - 1; index++) {
    const segmentStart = sortedBreakpoints[index];
    const segmentEnd = sortedBreakpoints[index + 1];

    if (segmentStart >= segmentEnd) {
      continue;
    }

    let coveringSpan: T | null = null;

    for (let spanIndex = ranges.length - 1; spanIndex >= 0; spanIndex--) {
      const span = ranges[spanIndex];

      if (span.start <= segmentStart && span.end >= segmentEnd) {
        coveringSpan = { ...span, start: segmentStart, end: segmentEnd };
        break;
      }
    }

    if (!coveringSpan) {
      continue;
    }

    const lastResolved = resolved[resolved.length - 1];

    if (
      lastResolved &&
      lastResolved.end === coveringSpan.start &&
      canMerge(lastResolved, coveringSpan)
    ) {
      lastResolved.end = coveringSpan.end;
    } else {
      resolved.push(coveringSpan);
    }
  }

  return resolved;
}
